function fetchProductData(productHandle) {
	return fetch(`/products/${productHandle}.js`)
		.then((response) => {
			if (!response.ok) {
				return Promise.reject("商品情報の取得に失敗しました。");
			}
			return response.json();
		});
}

function createBadgeElement(tags) {
	const badgeWrap = document.createElement("div");
	badgeWrap.classList.add("badge-wrap");

	const tagElement = document.createElement("span");
	for (const tag of tags) {
		if (tag === "NEW") {
			tagElement.classList.add("badge", "badge-new");
			tagElement.textContent = "NEW";
		}
	}

	if (tagElement.textContent) {
		badgeWrap.appendChild(tagElement);
	}

	return badgeWrap;
}

function createModalHeadingElement() {
	const modalHeading = document.createElement("div");
	modalHeading.classList.add("zrx-modal-container-heading");
	modalHeading.innerHTML = "<h2>カラーや数量をお選びください</h2>";

	const modalContainer = document.querySelector(".zrx-modal-product-container");
	modalContainer.prepend(modalHeading);
}

function createButtonWrapperElement() {
	const buttonWrapper = document.createElement("div");
	buttonWrapper.classList.add("zrx-modal-button-wrapper");
	const modalQuantityToggle = document.querySelector(".zrx-modal-quantity-toggle");
	const modalAddToCartButton = document.querySelector(".zrx-modal-add-to-cart-button");
	buttonWrapper.appendChild(modalQuantityToggle);
	buttonWrapper.appendChild(modalAddToCartButton);

	// .zrx-modal-full-details-wrapperの前にbuttonWrapperを挿入
	const fullDetailsWrapper = document.querySelector(".zrx-modal-full-details-wrapper");
	fullDetailsWrapper.before(buttonWrapper);

}

document.addEventListener("zrx-loaded", function () {
	const crosssellItems = window.zoorix_data.products;
	const productCards = document.querySelectorAll("[data-zrx-pid]");
	const productIds = Array.from(productCards).map((card) =>
		card.getAttribute("data-zrx-pid")
	);

	for (const productId of productIds) {
		const product = Object.values(crosssellItems).find(
			(item) => item.shopify_id === parseInt(productId)
		);
		const productHandle = product.handle;

		fetchProductData(productHandle)
			.then((product) => {
				const productTags = product.tags;
				const productCard = document.querySelector(
					`[data-zrx-pid="${productId}"]`
				);
				const details = productCard.querySelector(
					".zrx-slider-product-name"
				);
				details.textContent = details.textContent.replace(/\(.*?-no-color.*?\)/g, "");
				
				// const badgeWrap = createBadgeElement(productTags);

				// if (badgeWrap.children.length > 0) {
				// 	details.prepend(badgeWrap);
				// }
			})
			.catch((error) => {
				console.error("エラー:", error);
			});
	}
});

document.addEventListener("zrx-quick-view-opened", function () {
	const crosssellItems = window.zoorix_data.products;
	const modalProducttitle = document.querySelector(
		".zrx-modal-product-title.Heading"
	);
	const product = Object.values(crosssellItems).find(
		(item) => item.title === modalProducttitle.textContent
	);
	const productHandle = product.handle;

	fetchProductData(productHandle)
		.then((product) => {
			createModalHeadingElement();
			createButtonWrapperElement();
			// モーダルを開いた直後、表示中の画像と一致するセレクトボックスのoptionを選択状態にする（たまに一致しないパターンがあるため）
			const image = document.querySelector(".zrx-modal-product-image");
			let imageUrl = image.style.backgroundImage;
			imageUrl = imageUrl.replace('url("', '');
			imageUrl = imageUrl.replace('")', '');
			imageUrl = imageUrl.replace('_540x', '');

			const defaultSelectedVariant = product.variants.find(variant => variant.featured_image.src === imageUrl);

			const selectDefault = document.querySelector(".zrx-modal-select-container select");
			if(selectDefault) {
				// selectDefaultのoptionの中から、selectedVariant.titleと一致するものを選択状態にする
				for (let i = 0; i < selectDefault.options.length; i++) {
					if (selectDefault.options[i].value === defaultSelectedVariant.title) {
						selectDefault.options[i].selected = true;
						break;
					}
				}
			}

			// セレクトボックスの変更によって画像を切り替える
			const select = document.querySelector(".zrx-modal-select-container select");
			if(select) {
				select.addEventListener("change", function (e) {
					const selectedVariantName = e.target.value;
					const selectedVariant = product.variants.find(variant => variant.title === selectedVariantName);
					if (selectedVariant) {
						const image = document.querySelector(".zrx-modal-product-image");
						image.style.backgroundImage = `url(${selectedVariant.featured_image.src})`;
					}
				});
			}

		})
		.catch((error) => {
			console.error("エラー:", error);
		});




});

